import { NTDepartmentRole,  DepartmentRoleService } from "@nt-portal/server-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";
import { ResultData } from "@nt-portal/common-sdk";

export interface DepartmentRolesOptions extends ControllerOptions<NTDepartmentRole> {

}

export const initDepartmentRole = () => {
    let item: NTDepartmentRole = {
        role: { name: '', id: '', roleType: "module", description: "", key: "", level: 5} ,
        department: "",
        createdBy: ""
    }
    return item;
}

export class ClientDepartmentRoleService extends BaseClientService implements DataController<NTDepartmentRole> {

    private _service: DepartmentRoleService;


    constructor() {
        super();
        this._service = new DepartmentRoleService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }
    
   public async get(options: DepartmentRolesOptions): Promise<ResultData<NTDepartmentRole>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);
       
    }
    public async getLookup(options: DepartmentRolesOptions): Promise<ResultData<NTDepartmentRole>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token, options.filter);
        return data;
    }

    public async getById(options: DepartmentRolesOptions): Promise<NTDepartmentRole | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: DepartmentRolesOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: DepartmentRolesOptions): Promise<NTDepartmentRole | NTDepartmentRole[] | null> {
        if (options.item )
            return await this._service.update(options.item, this.token)
        return null;
    }
    public async add(options: DepartmentRolesOptions): Promise<NTDepartmentRole | NTDepartmentRole[] | null> {
        if (options.item )
            return await this._service.add(options.item, this.token)
        return null;
    }
   


}